import React from 'react'
import moment from 'moment'
import Modal from '../../components/Modal'
import StarReviewComponent from '../../components/StarReviewComponent'
import Button from '../../components/Button'

class ReviewsModal extends React.Component {
  state = {
    page: 1
  }

  loadMore = () => {
    this.setState(({ page }) => ({
      page: page + 1
    }))
  }

  render() {
    const { isOpen, onRequestClose, product, quantity, reviews } = this.props
    const { page } = this.state
    let reviewsToShow = page * 10

    reviewsToShow =
      reviewsToShow >= reviews.length ? reviews.length : reviewsToShow

    return (
      <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
        <div className="header-modal">
          <h2 className="title-section">Customer Reviews</h2>
        </div>
        <div className="title-box">
          <div className="review-count-container">
            <p>{product.stars ? parseFloat(product.stars).toFixed(2) : null}</p>
            <div className="column-container">
              <StarReviewComponent
                name="rate"
                starCount={5}
                value={product.stars}
                onStarClick={() => {}}
              />
              <p className="total-reviews">
                Based on {quantity} <span>reviews</span>{' '}
              </p>
            </div>
          </div>
        </div>
        <div className="slider-container">
          {reviews.slice(0, reviewsToShow).map(review => (
            <div className="content" key={review.id}>
              <div className="info">
                <div className="stars">
                  <StarReviewComponent
                    name="rate"
                    starCount={5}
                    value={review.stars}
                    onStarClick={() => {}}
                  />
                </div>
                <p>{review.detail}</p>
                <div className="row-reviews">
                  <p>
                    {review.customerName
                      ? review.customerName
                      : review.nickname}
                    <span>
                      {moment(review.createdAt, 'YYYY-MM-DD hh:m:s').format(
                        'MM/DD/YY'
                      )}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {reviewsToShow !== reviews.length && (
          <Button
            onClick={this.loadMore}
            style={{ margin: '0 auto', display: 'block' }}>
            Load more
          </Button>
        )}
      </Modal>
    )
  }
}

export default ReviewsModal



// WEBPACK FOOTER //
// ./src/components/Reviews/ReviewsModal.jsx